"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraOff = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var CameraOff = function CameraOff() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.82 22.8018L23.184 23.4378C22.9507 23.6665 22.5773 23.6665 22.344 23.4378L18.516 19.6098C18.0764 20.0974 17.4562 20.3836 16.8 20.4018H2.4C1.07452 20.4018 0 19.3273 0 18.0018V6.00182C0 4.67634 1.07452 3.60182 2.4 3.60182L0.528 1.65782C0.411987 1.54894 0.346178 1.39693 0.346178 1.23782C0.346178 1.07872 0.411987 0.926702 0.528 0.817822L1.2 0.181822C1.30888 0.0658097 1.4609 0 1.62 0C1.7791 0 1.93112 0.0658097 2.04 0.181822L23.82 21.9978C24.0261 22.2262 24.0261 22.5734 23.82 22.8018ZM19.2 14.4018L8.39997 3.6018H16.8C18.1255 3.6018 19.2 4.67632 19.2 6.0018V9.6018L22.452 6.3498C22.6755 6.12811 22.9772 6.00313 23.292 6.0018H23.4C23.7313 6.0018 24 6.27043 24 6.6018V17.4018C24 17.7332 23.7313 18.0018 23.4 18.0018H23.292C22.9772 18.0005 22.6755 17.8755 22.452 17.6538L19.2 14.4018ZM7.404 8.54583L9.42 10.4658L9.372 10.5138C9.26911 10.6046 9.13719 10.6557 9 10.6578H4.2C3.86863 10.6578 3.6 10.3892 3.6 10.0578V9.14582C3.6 8.81445 3.86863 8.54583 4.2 8.54583H7.404Z"
  });
};

exports.CameraOff = CameraOff;